import { render, staticRenderFns } from "./CreatePoint.vue?vue&type=template&id=19d0dec6&scoped=true"
import script from "./CreatePoint.vue?vue&type=script&lang=js"
export * from "./CreatePoint.vue?vue&type=script&lang=js"
import style0 from "./CreatePoint.vue?vue&type=style&index=0&id=19d0dec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0dec6",
  null
  
)

export default component.exports